export default __webpack_public_path__ + "static/media/person_gray.aca15d6e.svg";